module.exports = __webpack_public_path__ + "static/media/14.4eb534aa.jpg";